import { Injectable, ApplicationRef, createComponent, EnvironmentInjector } from '@angular/core';
import { MessageDialogComponent } from './message-dialog.component';
import { Subject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class DialogService {

    constructor(private appRef: ApplicationRef, private environmentInjector: EnvironmentInjector) {}

    show(title: string, message: string, type: string): Subject<boolean> {
        const component  = createComponent(MessageDialogComponent, {environmentInjector: this.environmentInjector});

        const result$ = component.instance.show(title, message, type);

        this.appRef.attachView(component.hostView);
        const element = (component.hostView as any).rootNodes[0] as HTMLElement;

        document.body.appendChild(element);

        result$.subscribe(() => {
            this.appRef.detachView(component.hostView);
            component.destroy();
        });

        return result$;
    }
}
